import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import API from "./api";

const CHAT_SLOT_ID = "chat-slot";
const CHAT_LOADER_ID = "chat-loader-script";
const CHAT_LOADER_SRC = "/js/chat-loader.js";

// Routes that must never show the chat widget: they deal with wallet
// provisioning token exchange or PCI-scoped PIN entry, so no third-party
// content (even a sandboxed iframe) should be mounted alongside them.
const SENSITIVE_ROUTE_PATTERNS = [
    /^\/provision\/?$/,
    /^\/[^/]+\/change-pin\/?$/,
];

const isSensitiveRoute = (pathname) =>
    SENSITIVE_ROUTE_PATTERNS.some((re) => re.test(pathname));

/**
 * Mounts the Dialect Communications chat widget for brands with
 * cardConfig.hasChat, using the security-hardened embedding: a fixed-size
 * #chat-slot plus our own self-hosted /js/chat-loader.js, which renders the
 * vendor's widget inside a sandboxed, origin-checked iframe. See decision
 * "Dialect chat widget: security-hardened embedding" in shared context.
 */
const ChatButton = () => {
    const api = API();
    const location = useLocation();
    const [hasChat, setHasChat] = useState(false);

    useEffect(() => {
        let cancelled = false;
        api.getClientConfig()
            .then(clientConfig => {
                if (!cancelled) setHasChat(Boolean(clientConfig?.cardConfig?.hasChat));
            })
            .catch(() => {});
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const shouldRender = hasChat && !isSensitiveRoute(location.pathname);

    useEffect(() => {
        if (!shouldRender || document.getElementById(CHAT_LOADER_ID)) {
            return;
        }
        const script = document.createElement('script');
        script.id = CHAT_LOADER_ID;
        script.src = CHAT_LOADER_SRC;
        document.body.appendChild(script);
    }, [shouldRender]);

    if (!shouldRender) {
        return null;
    }

    return (
        <div
            id={CHAT_SLOT_ID}
            style={{
                position: "fixed",
                right: 0,
                bottom: 0,
                overflow: "hidden",
                width: "99px",
                height: "103px",
                zIndex: 999,
            }}
        />
    );
};

export default ChatButton;
